import { combineReducers } from 'redux';
import CoreReduxStore from '@/core/reducers/CoreReduxStore';


const SimpleServiceStore = ( screenCode:string, serviceCode:string = "" ) => {
    const reduxStorages = new CoreReduxStore({ screenCode: screenCode, serviceCode: serviceCode });

    return combineReducers({

        ...reduxStorages.POST()
    
    });
}

export default SimpleServiceStore;
